import { Airframe } from "../../../../types/airframe";
import { getOwnershipStatusLabel } from "../../../../constants/ownershipStatus";
import { DisplayPreferences } from "../../../../hooks/useTenantDisplayPreferences";

export type AirframeField = {
  id: string;
  label: string;
  getValue: (pkg: Airframe) => string | number | undefined | null;
};

export type AirframeFieldSection = {
  title: string;
  fields: AirframeField[];
};

export const AIRFRAME_FIELD_SECTIONS: AirframeFieldSection[] = [
  {
    title: "Basic Information",
    fields: [
      { id: "manufacturer", label: "Manufacturer", getValue: (p) => p.manufacturer },
      { id: "model", label: "Model", getValue: (p) => p.model },
      { id: "tailNumber", label: "Tail Number", getValue: (p) => p.tailNumber },
      { id: "serialNumber", label: "Serial Number", getValue: (p) => p.serialNumber },
      { id: "dateManufactured", label: "Date Manufactured", getValue: (p) => p.dateManufactured },
    ],
  },
  {
    title: "Flight Details",
    fields: [
      { id: "totalFlightHours", label: "Total Flight Hours", getValue: (p) => p.totalFlightHours },
      { id: "totalFlightCycles", label: "Total Flight Cycles", getValue: (p) => p.totalFlightCycles },
    ],
  },
  {
    title: "Heavy Maintenance Visit (HMV)",
    fields: [
      {
        id: "lastHMVDate",
        label: "Last HMV Date",
        getValue: (p) => (p.lastHMVDate ? p.lastHMVDate : undefined),
      },
      {
        id: "lastHMVType",
        label: "Last HMV Type",
        getValue: (p) => (p.lastHMVType ? p.lastHMVType : undefined),
      },
    ],
  },
  {
    title: "Categories",
    fields: [
      { id: "operationalCategory", label: "Operational Category", getValue: (p) => p.operationalCategory },
      { id: "landingCategory", label: "Landing Category", getValue: (p) => p.landingCategory },
      { id: "etopsCategory", label: "ETOPS Category", getValue: (p) => p.etopsCategory },
    ],
  },
];

const OWNERSHIP_FIELDS: AirframeField[] = [
  {
    id: "operatorName",
    label: "Operator",
    getValue: (p) => (p.operatorName?.trim() ? p.operatorName : "N/A"),
  },
  {
    id: "ownershipStatus",
    label: "Ownership Status",
    getValue: (p) =>
      getOwnershipStatusLabel(p.ownershipStatus, p.ownershipStatusLabel)?.trim() || "N/A",
  },
];

/** Ownership columns for the airframe grid, respecting tenant display preferences. */
export function getAirframeOwnershipFields(
  preferences: DisplayPreferences
): AirframeField[] {
  return OWNERSHIP_FIELDS.filter((field) => {
    if (field.id === "ownershipStatus") return preferences.showOwnershipStatus;
    if (field.id === "operatorName") return preferences.showOperator;
    return true;
  });
}

export function formatAirframeCellValue(value: string | number | undefined | null): string {
  if (value === undefined || value === null || value === "") {
    return "—";
  }
  return String(value);
}
